import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "SwitchUser",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { switchUser, switchUserError, switchUserSuccess } = slice.actions;

reducerRegistry.register("switchUser", reducer);
